import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import bizGlobal from 'src/redux/action/bizGlobal';
import { Alert, notification, Popover, Spin } from 'antd';
import 'src/ant-custom-css/table.css';
import { MessageOpt } from 'src/eventEmits/message';
import useMessage from 'src/hooks/useMessage';
import eventEmitter from 'src/eventEmits';
import lessStyle from './index.module.less';
import Header from '../components/HomeHeader';
import IconBass from "../../components/IconBass";
import ChangePrice from '../components/ChangePrice';

const { GET_MENUS_AUTH, GET_AUTH_INFO, GET_ACCOUNT_BALANCE, GET_ACCOUNT_TYPE } = bizGlobal;

export default function Admin() {
  const messageApi = useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const bizGlobalReducers = useSelector((state: any) => state.bizGlobalReducers || {});
  const { authInfo = {}, menusAuth = [], accountBalance = 0, accountType, rechargeVisible } = bizGlobalReducers;

  const [api, contextHolder] = notification.useNotification({
    top: 94,
  });

  // useEffect(() => {
  //   api.error({
  //     message: '临时停服通知',
  //     description: (
  //       <>
  //         为保障数据安全合规和平台稳定运行，
  //         <span style={{ color: '#ff4d4f', fontWeight: 'bold' }}>
  //           数据源服务端临时暂停”全国核心资产查询“服务，预期在6月初恢复
  //         </span>
  //         ，请您耐心等待。我们将实时跟进维护进度，服务恢复事宜将第一时间同步。此次临时暂停给您带来的不便，我们深表歉意，衷心感谢您的理解与支持!
  //       </>
  //     ),
  //     duration: 0,
  //     // closable: false,
  //     style: {
  //       width: 300,
  //     },
  //   });
  // }, []);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      dispatch<any>(GET_MENUS_AUTH()),
      dispatch<any>(GET_AUTH_INFO()),
      dispatch<any>(GET_ACCOUNT_BALANCE()),
      dispatch<any>(GET_ACCOUNT_TYPE()),
    ]).finally(() => {
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    if (authInfo?.userStatus === 0 && accountType === 'office') {
      if (!window.location.href.includes('/admin/authentication')) {
        dispatch<any>(GET_ACCOUNT_TYPE('person'));
        window.location.reload();
      }
    }
  }, [authInfo, accountType]);

  /**
   * 低版本浏览器兼容处理
   * 处理 antd message 组件
   */
  useEffect(() => {
    const messageCallback = (option: MessageOpt) => {
      const { type, options: msgOpt } = option;
      messageApi[type](msgOpt);
    };
    eventEmitter.on('message', messageCallback);
    return () => {
      eventEmitter.off('message', messageCallback);
    };
  }, []);

  return (
    <Spin spinning={isLoading}>
      {contextHolder}
      <div className={lessStyle['admin-container']}>
        <Header />
        <div className={lessStyle['admin-content']}>
          <Outlet />
        </div>
        <Popover
          rootClassName="home-popover-wrap-root-class-name"
          content={(
            <div className={lessStyle['code-wrap']}>
              <img
                className={lessStyle['code-img']}
                src={require('./images/code.jpeg')}
                alt=""
              />
              <div className={lessStyle['code-text']}>
                微信咨询
              </div>
            </div>
          )}
          trigger="hover"
          placement="left"
        >
          <div className={lessStyle['wechat-info-wrap']}>
            <div className={lessStyle.wechatInner}>
              <IconBass type="iconweixin_wechat" className={lessStyle.icon} />
              <div className={lessStyle['wechat-info-text']}>
                微信咨询
              </div>
            </div>
          </div>
        </Popover>

        <ChangePrice />
      </div>
    </Spin>
  );
}
